// extracted by mini-css-extract-plugin
export var locationCard = "_fx-0";